export default __webpack_public_path__ + "images/oralHealthReport.46140d42a8f21839c9c723eb04b62862.svg";